import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconTokens, MessageAlignType, MessageTypeTokens, } from '@voltmoney/schema';
export const args = {
    label: '',
    actionText: 'Confirm',
    labelColor: ColorTokens.Grey_Charcoal,
    bgColor: ColorTokens.System_Warning_BG,
    alignText: MessageAlignType.CENTER,
    customLabel: {
        label: 'Test Custom data',
        color: ColorTokens.Grey_Charcoal,
        lineHeight: 28,
        fontSize: FontSizeTokens.XXS,
        fontFamily: FontFamilyTokens.Inter,
        fontWeight: '500',
    },
    icon: {
        name: IconTokens.Info,
        color: ColorTokens.Grey_Smoke,
    },
};
export const argTypes = {
    state: {
        control: 'select',
        options: [
            ...Object.values(MessageTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    align: {
        control: 'select',
        options: [
            ...Object.values(MessageAlignType).filter((k) => typeof k === 'string'),
        ],
    },
    onPress: { action: 'clicked' },
};
